function bind (el) {
  const mask = document.createElement('div')
  mask.style.width = '100%'
  mask.style.height = '100%'
  mask.className = 'loading-mask'

  const loading = document.createElement('img')
  loading.setAttribute('src', './loading.gif')
  loading.style.position = 'absolute'
  loading.style.margin = 'auto'
  loading.style.top = 0
  loading.style.bottom = 0
  loading.style.left = 0
  loading.style.right = 0
  loading.style.width = '2rem'
  mask.appendChild(loading)
  el.style.position = 'relative'
  el.appendChild(mask)
}
export default {
  install (Vue) {
    Vue.directive('loading', {
      bind (el, binding) {
        if (binding.value && binding.oldValue !== binding.value) {
          bind(el)
        }
      },
      update (el, binding) {
        if (!binding.value && binding.oldValue !== binding.value) {
          const nowMask = el.classList[0] ? document.querySelector(`.${el.classList[0]} .loading-mask`) : document.querySelector('.loading-mask')
          el.removeChild(nowMask)
          el.style.position = ''
        } else if (binding.value && binding.oldValue !== binding.value) {
          bind(el)
        }
      }
    })
  }
}
